export const TABLE_ROW = 'TABLE_ROW'
